import { Button, Input, Table } from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useRedis } from '@/hooks/useRedis'
import numberUtils from '@/utils/numberUtils'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

interface PriceList {
  bizCd?: string //업체코드
  bizNm?: string //업체명
  glfPrceCd?: string //골프장가격코드
  glfPrceNm?: string //골프장가격명
  curr?: string //통화단위
  prce?: string //가격
  updtYn?: string //업데이트 여부
  baseDt?: string //기준일자
}

interface GetRequestPrice {
  bizCd?: string //업체코드
}

export const PriceMgmt = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const { showAlert, showConfirm } = useDialog()

  const [priceList, setPriceList] = useState<PriceList[]>([])

  const { getComCodeValue, getComCodes } = useRedis()

  const location = useLocation()
  const [requestData] = useState({
    bizCd: String(location.state?.bizCd),
    rem: location.state?.rem,
  })

  useEffect(() => {
    getPriceList()
  }, [])

  //가격조회
  const getPriceList = async () => {
    try {
      const data: GetRequestPrice = {
        bizCd: requestData.bizCd,
      }

      const response = await axios.get('/priceMgmt/getPriceMgmtList', {
        params: { ...data },
      })

      const priceList = response.data

      if (Array.isArray(priceList)) {
        setPriceList(priceList.map((price) => ({
          ...price,
          curr : price.curr || 'KRW',
          updtYn: price.updtYn || getComCodes('UPDT_YN')[0].code || 'Y'
        })))
      }
    } catch (err: any) {
      console.error('༼ つ ◕_◕ ༽つ Error fetching priceManage:', err)
    }
  }

  // 특정 셀 값 변경 함수
  const handleInputChange = (
    index: number,
    field: keyof PriceList,
    value: string,
  ) => {
    let newValue = value

    if (field === 'prce') {
      newValue = newValue.replace(/[^0-9]/g, '') // 숫자 외 문자 제거
    }

    const newData = [...priceList]
    newData[index] = { ...newData[index], [field]: newValue } // 해당 필드 업데이트
    setPriceList(newData)
  }

  // 저장 함수: 해당 행의 데이터를 외부로 전달
  const handleSave = (index: number) => {
    const rowToSave = priceList[index] // 해당 행의 데이터
    fetchSave(rowToSave)
  }

  const fetchSave = async (rowToSave: PriceList) => {
    if (rowToSave) {
      rowToSave.bizCd = requestData.bizCd

      if (!rowToSave?.bizCd) {
        showAlert({
          title: '업체코드가 없습니다. 비정상적인 접근. 다시 시도해주세요.',
        })
        return
      }

      if (!rowToSave?.glfPrceCd) {
        showAlert({
          title: '가격코드가 없습니다. 비정상적인 접근. 다시 시도해주세요.',
        })
        return
      }

      if (!rowToSave?.prce) {
        showAlert({ title: '가격을 입력해주세요.' })
        return
      }

      if (!rowToSave?.baseDt) {
        showAlert({ title: '기준일자를 입력해주세요.' })
        return
      }

      if (!rowToSave?.updtYn) {
        showAlert({ title: '업데이트여부를 입력해주세요.' })
        return
      }

      try {
        const response = await axios.post(
          '/priceMgmt/insPriceMgmt',
          rowToSave,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        //TODO. API에서 성공여부 코드로 보내기
        if (response.status === 200) {
          showAlert({
            type: 'success',
            title: '저장을 성공했어요.',
          })
        } else {
          showAlert({
            title: '저장을 실패했어요. 잠시 후 다시 시도해 주세요.',
          })
        }
      } catch (err: any) {
        showAlert({
          title: '오류가 발생했어요. 잠시 후 다시 시도해주세요.',
        })
        console.error('Error updating biz:', err)
      }
    } else {
      console.log('저장된 데이터가 없습니다.')
      return
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '50px',
        }}
      >
        <div style={{ marginLeft: '20px', fontSize: '20px' }}>
          가격관리
          <br />
          <span
            style={{ fontSize: '18px', cursor: 'pointer' }}
            onClick={() => window.open(location.state?.chrgeDomain, '_blank')}
          >
            {'업체명 : '}
            {priceList.length > 0
              ? priceList[0].bizNm || priceList[3].bizNm
              : ''}
          </span>
          <br/>
          <span
            style={{ fontSize: '18px', display: 'inline-block', maxWidth: '40rem'}}
            title={requestData.rem}
          >
            {'비고 : '+requestData.rem}
          </span>
        </div>
        <div style={{ marginRight: '20px' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <Button
              onClick={() =>
                // showConfirm({
                //   title: '목록으로 이동할까요?',
                //   onConfirm() {
                //     navigate('/bizMgmt', {
                //       state: {
                //         bizSearchState: location.state?.bizSearchState,
                //       },
                //     })
                //   },
                // })
                navigate('/bizMgmt', {
                  state: {
                    bizSearchState: location.state?.bizSearchState,
                  },
                })
              }
              color="neverbe"
            >
              목록
            </Button>
          </div>
        </div>
      </div>

      <Table color="secondary" hover={true} striped={true}>
        <thead>
          <tr>
            <th scope="col" style={{ textAlign: 'center' }}>
              업체코드
            </th>
            <th scope="col" colSpan={2} style={{ textAlign: 'center' }}>
              골프장가격코드
            </th>
            <th scope="col" style={{ textAlign: 'center' }}>
              통화단위
            </th>
            <th scope="col" style={{ textAlign: 'center' }}>
              가격
            </th>
            <th scope="col" style={{ textAlign: 'center' }}>
              기준일자
            </th>
            <th scope="col" style={{ textAlign: 'center' }}>
              업데이트여부
            </th>
            <th scope="col" style={{ textAlign: 'center' }}></th>
            <th scope="col" style={{ textAlign: 'center' }}></th>
          </tr>
        </thead>
        <tbody>
          {priceList.map((item, index) => (
            <tr key={item.glfPrceCd}>
              <td>{requestData.bizCd}</td>
              <td>{item.glfPrceCd}</td>
              <td>{item.glfPrceNm}</td>
              <td>
                <Input
                  id="curr"
                  name="curr"
                  type="text"
                  value={item.curr}
                  style={{ textAlign: 'center' }}
                  onChange={(e) =>
                    handleInputChange(index, 'curr', e.target.value)
                  }
                />
              </td>
              <td>
                <Input
                  id="prce"
                  name="prce"
                  type="text"
                  value={numberUtils.formatNumberWithCommas(Number(item.prce))}
                  style={{ textAlign: 'right' }}
                  onChange={(e) =>
                    handleInputChange(index, 'prce', e.target.value)
                  }
                />
              </td>
              <td>
                <Input
                  id="baseDt"
                  name="baseDt"
                  type='date'
                  value={item.baseDt}
                  onChange={(e) =>
                    handleInputChange(index, 'baseDt', e.target.value)
                  }
                />
              </td>
              <td>
                <Input
                  id="updtYn"
                  name="updtYn"
                  type="text"
                  value={item.updtYn}
                  style={{ textAlign: 'center' }}
                  onChange={(e) =>
                    handleInputChange(index, 'updtYn', e.target.value)
                  }
                />
              </td>
              <td style={{ textAlign: 'center' }}>
                <Button
                  variant="outlined"
                  color="neverbe"
                  size="xs"
                  onClick={() =>
                    showConfirm({
                      title: '변경사항을 저장할까요?',
                      onConfirm() {
                        handleSave(index)
                      },
                    })
                  }
                >
                  저장
                </Button>
              </td>
              <td style={{ textAlign: 'center' }}>
                {item.bizCd && (
                  <Button
                    variant="outlined"
                    color="neverbe"
                    size="xs"
                    onClick={() =>
                      navigate('/bizMgmt/priceHistMgmt', {
                        state: {
                          bizCd: item.bizCd,
                          glfPrceCd: item.glfPrceCd,
                          bizSearchState: location.state?.bizSearchState,
                        },
                      })
                    }
                  >
                    이력
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}

export default PriceMgmt
